import * as React from 'react';

import { AdfoxBannerContainer, IAdfoxBannerContainerProps } from '../AdfoxBannerContainer';

const P_PARAMS: IAdfoxBannerContainerProps['pParams'] = { p1: 'dfdrs', p2: 'fjjq' };
const POST_VIEW_ANALYTICS_DATA: IAdfoxBannerContainerProps['postViewAnalyticsData'] = {
  place: 'recs',
  place__DEPRECATED: 'recs',
  name__DEPRECATED: 'Home_recs_brand_banner',
  extra__DEPRECATED: {
    offerType: 'Brand_banner',
  },
};
const SIZE: IAdfoxBannerContainerProps['size'] = { width: '100%', height: 93 };

export function AdfoxBrandBannerContainer() {
  return <AdfoxBannerContainer pParams={P_PARAMS} size={SIZE} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} />;
}
